import React, {Component} from "react";
import {message, Modal} from "antd";
import {map} from 'lodash';
import moment from 'moment-timezone';
import * as yup from "yup";

class EmailRemainder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cardDetail: {},
      emailText: '',
      useStandardEmail: false,
      errors: {}
    };
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    // set card details
    if (nextProps?.cardDetail && Object.keys(nextProps?.cardDetail).length > 0) {
      this.setState({cardDetail: nextProps?.cardDetail})
    }
  };

  // render email log record
  renderEmailLog = (item, index) => {
    const expDate = `${item.expired_month}/01/${item.expired_year}`;
    const diff = moment(expDate).diff(moment(), 'days');
    const displayDiff = moment(expDate).fromNow();
    const displayText = diff < 0 ? `expired for ${displayDiff}` : `will expire ${displayDiff}`;
    return (
      <div key={`log${index}`}>{`Email reminder${item.automatically_sent ? ' automatically' : ''} sent, ${moment(item.created_at).format('MMMM DD, YYYY')} (${displayText})`}</div>
    )
  };

  // on text change
  onTextChange = (e, type) => {
    const {customer} = this.props;
    const defaultEmail = `Hi ${customer?.first_name}, \n\n We notice your CC is about to expire this month. To make sure your service continues without disruption, you can update your payment details in DoodyCalls Online, or call our callcenter on +1 444 555 6666.\n\n Thanks, \n Doody Calls\n\n`;

    const value = type === 'bool' ? e.target.checked : e.target.value;
    if (e.target.name === 'useStandardEmail') {
      this.setState({emailText: value ? defaultEmail : ''});
    }
    this.setState({[e.target.name]: value});
  };

  // validate required fields
  validate = () => {
    const {emailText} = this.state;

    const schema = yup.object().shape({
      emailText: yup.string().required("Email body is required"),
    });

    const data = {emailText}

    setTimeout(() => {
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({ is_btn_active: true, errors: {} });
        this.onOkClick()
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {err_data[item.path] = item.message})
        this.setState({errors: err_data, is_btn_active: false})
      });
    }, 200);
  };

  //on clear
  onClear = () => {
    this.setState({emailText: '', useStandardEmail: false});
  };

  // on send email reminder click
  onOkClick = () => {
    const {cardDetail, emailText} = this.state;
    const {handleOk, handleCancel} = this.props;
    handleOk({
      user_billing_info_uuid: cardDetail?.uuid,
      email_body: emailText, 
      expired_month: cardDetail?.stripe_card_details?.exp_month,
      expired_year: cardDetail?.stripe_card_details?.exp_year  
    });
    handleCancel();
    this.onClear();
  };

  render() {
    const {visible, handleCancel} = this.props;
    const {emailText, useStandardEmail, cardDetail, errors} = this.state;

    return (
      <Modal
        title="Send Reminder Email for CC Expiry"
        visible={visible}
        onCancel={() => {this.onClear(); handleCancel()}}
        footer={[
          <button key="cancel" className="btn btn-brand btn-bdr" onClick={() => {this.onClear(); handleCancel()}}>Cancel</button>,
          <button
            key="submit"
            className={`btn btn-warning`}
            // disabled={!emailText}
            onClick={() => this.validate()}
          >Send Reminder</button>
        ]}
      >
        <div className="form-group">
          <div className="fitem">
            <label htmlFor="emailText">Email to Customer</label>
            <textarea
              id={"emailText"}
              rows="4"
              name="emailText"
              type="text"
              placeholder={"Email to Customer"}
              value={emailText}
              onChange={(e) => this.onTextChange(e)} />
            {errors?.['emailText'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['emailText']}</label> : ''}
          </div>
          <div className="inline-check-list gcheck">
            <div className="fitem-check">
              <input
                type="checkbox"
                className="fitem-ck-input"
                style={{ "visibility": "visible", "width": "20px", "height": "20px", "zIndex": "9"}}
                id="checkbox"
                name="useStandardEmail"
                checked={useStandardEmail}
                onChange={(e) => this.onTextChange(e, 'bool')} />
              <label htmlFor="checkbox" className="fitem-ck-txt">Use standard email</label>
            </div>
          </div>
          <hr/>
          <div>
            <h5>Email sent log</h5>
            <div>
              {
                map(cardDetail?.email_reminder, this.renderEmailLog)
              }
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

export default EmailRemainder;
